//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Container from "spoferan-ui/src/components/Layout/Container";
import Icon from "spoferan-ui/src/components/Icon/Icon";
import Wrapper from "spoferan-ui/src/components/Layout/Wrapper";
import Btn from "spoferan-ui/src/components/Button/Btn";
import {isString} from "spoferan-ui/src/helpers/string_helpers";

export default {
    name: 'NuxtError',

    components: {Container, Icon, Wrapper, Btn},

    props: {
        error: {
            type: Object,
            default: null
        }
    },
    head() {
        return {
            title: this.errorTitle,
            meta: [
                {
                    name: 'viewport',
                    content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
                }
            ]
        }
    },

    computed: {
        isOffline() {
            return this.$nuxt.isOffline || this.error.message === 'Network Error';
        },

        statusCode() {
            return (this.error && this.error.statusCode) || 500
        },

        errorTitle() {
            if (this.isOffline) {
                return this.$t('error.offline.title')
            }

            return this.$t(`error.${this.statusCode}.title`)
        },

        message() {
            if (this.isOffline) {
                return this.$t('error.offline.message')
            }

            let showServerMessageResponseCodes = [404, 403];
            if ((this.$config.debug === 'true' || this.$config.debug === true || showServerMessageResponseCodes.indexOf(this.statusCode) > 0) && this.error.message && isString(this.error.message) && this.error.message !== 'This page could not be found') {
                return this.error.message;
            }
            return this.$t(`error.${this.statusCode}.message`)
        }
    },

    watch: {
        '$nuxt.isOnline'(value) {
            if (value) {
                this.reloadPage();
            }
        },
    },

    mounted() {
        this.$nextTick(function () {

            // Timeout to make sure the new route data has been loaded on the '$route' instance, otherwise we would get the path of the referrer route
            setTimeout(() => {
                if (this.$sentry && this.error.statusCode === 404) {
                    this.$sentry.captureMessage('Page "' + this.$route.path + '" could not be found.');
                }
            }, 0);

            if (this.error.statusCode === 500
                && this.canBeFixedByReload()
                && window.location.hash !== '#retry') {
                this.reloadPage();
            }

        });
    },

    methods: {

        /**
         * Checks whether the error does not exist anymore when we reload the page.
         *
         * @returns {boolean}
         */
        canBeFixedByReload() {
            return /^Loading chunk [0-9]+ failed/.test(this.error.message) || /^Maximum call stack size exceeded/.test(this.error.message)
        },

        reloadPage() {
            // Mark the page to don't trigger reload infinitely
            window.location.hash = '#retry'
            window.location.reload(true)
        }
    }
}
